<template>
  <div id="app">
    <div class="page-wrapper">
      <header>
        <p>Driver Licence Check</p>
        <router-link v-if="isLoggedIn && !isProfileRoute" to="/profile">My details</router-link>
        <router-link v-if="isLoggedIn && isProfileRoute" to="/consents">My approvals</router-link>
      </header>
      <router-view></router-view>
    </div>
    <footer>
      &copy; {{new Date().getFullYear()}} Fonix Telematics
      <router-link v-if="isLoggedIn" to="/logout">Logout</router-link>
      <small class="version"> \ v{{version}}</small>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

/* global __VERSION__ */
export default {
  name: 'app',
  computed: {
    ...mapGetters(['isLoggedIn']),
    isProfileRoute () {
      return this.$route.name === 'driver-profile'
    }
  },
  data () {
    return {
      version: __VERSION__
    }
  }
}

</script>
<style lang="scss">
@import '~@/assets/styles/base';

html,
body,
#app {
  height: 100%;
  min-width: 400px;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  $footer-h: 20px;
  $footer-pad: 0.5rem;

  background: #f1f1f1;
  overflow: auto;

  .page-wrapper {
    min-height: calc(100% - (#{$footer-h} + #{$footer-pad * 2}));
  }

  header,
  footer {
    background: $primary-color;
  }

  header {
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  header a {
    color: #d6d6d6;
    text-decoration: none;
    font-size: 0.75rem;
    text-transform: uppercase; // color: white;
    &:hover {
      text-decoration: underline
    }

    &.router-link-active {
      display: none;
    }
  }

  footer {
    margin: 0;

    height: $footer-h;
    padding: $footer-pad;
  }

  footer a {
    color: #c0c0c0;
    float: right;
    font-size: 0.9rem;
  }

  .version {
    font-size: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue?1283f076